import moment from "moment";
import { teamAreasByFormProject } from "../types/initStore/initUser";

export const getAllUserCheck = (array = []) => {
    let newUsers = [];
    let allUser = [];
    let activeUser = {
        name: "Activos",
        number: 0,
        color: "green",
    };
    let desactiveUser = {
        name: "Eliminados",
        number: 0,
        color: "red",
    };

    const countUser = [];

    array.forEach((user) => {
        const structure = {
            key: user.email,
            ...user,
        };
        if (user.isActive) {
            newUsers.push(structure);
            activeUser.number++;
        } else {
            desactiveUser.number++;
        }
        allUser.push(structure);
    });

    countUser.push(activeUser, desactiveUser);
    return {
        newUsers,
        allUser,
        countUser,
    };
};

export const structureFormUser = (form, areasUser) => {
    let areasSelect = [];
    const { area, ...restForm } = form;
    area.forEach((are) => {
        const findArea = areasUser.find((areaRedux) => areaRedux.name === are);
        if (findArea) {
            areasSelect.push(findArea._id);
        }
    });
    const structureForm = {
        ...restForm,
        areas: areasSelect,
        startedDate: form.startedDate ? moment(form.startedDate._d).format() : null,
        fullTimeDate: form.fullTimeDate ? moment(form.fullTimeDate._d).format() : null,
    };

    return structureForm;
};

export const structureSelectUserByFormProject = (users = [], areasInmersys = []) => {
    const leader = [];
    const comercial = [];
    const responsible = [];
    const desing = [];
    const art3d = [];
    const web = [];
    const unity = [];
    const notTeam = [];

    users.forEach((user) => {
        user.area.forEach((are) => {
            const findArea = areasInmersys.find((filArea) => filArea._id === are.areaUserId);
            const nameFind = findArea ? findArea.name : "";
            const structurUser = {
                ...user,
            };
            if (teamAreasByFormProject.leader === nameFind) {
                leader.push(structurUser);
            }
            if (teamAreasByFormProject.comercial === nameFind) {
                comercial.push(structurUser);
            }
            if (teamAreasByFormProject.responsible === nameFind) {
                responsible.push(structurUser);
            }
            if (teamAreasByFormProject.desing === nameFind) {
                desing.push(structurUser);
            }
            if (teamAreasByFormProject.web === nameFind) {
                web.push(structurUser);
            }
            if (teamAreasByFormProject.unity === nameFind) {
                unity.push(structurUser);
            }
            if (teamAreasByFormProject.art3d === nameFind) {
                art3d.push(structurUser);
            }
            if (nameFind === "") {
                notTeam.push(structurUser);
            }
        });
    });

    return {
        leader,
        comercial,
        responsible,
        desing,
        art3d,
        web,
        unity,
        notTeam,
    };
};

export const structureSelectTeam = (users = []) => {
    let dataUser = {
        responsible: [],
        leader: [],
        comercial: [],
        art3d: [],
        desing: [],
        unity: [],
        web: [],
    };

    Object.entries(users).forEach(([key, user]) => {
        if (!dataUser[key]) {
            return;
        }
        user.iteams.forEach((element) => {
            dataUser[key].push(element.name);
        });
    });

    return dataUser;
};

export const setNewUsersWhithArea = (users = [], areas = []) => {
    const newUsers = users.map((user) => {
        const newArea = user.area.map((area) => {
            let newName = area.name;
            const findArea = areas.find((areaTeam) => areaTeam._id === area.areaUserId);
            if (findArea) {
                newName = findArea.name;
            }
            return {
                ...area,
                name: newName,
            };
        });

        return {
            ...user,
            area: newArea,
        };
    });
    return { newUsers };
};

export const createAdminName = (name = "") => {
    if (!name) return "";

    return name.split(" ").slice(0, 2).join(" ");
};
